import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Form, Button, Image } from 'react-bootstrap';
import Backend from "../../Backend";
import Connection from '../../Calls';
import { store } from 'react-notifications-component';
import SelectWalletCoins from "../Select/SelectWalletCoins";

const ModalWallets = ({title, show, onHide, wallets, coins, ...props}) => {
  const [coinWallet, setCoinWallet] = useState('')
  const [aliasWallet, setAliasWallet] = useState('')
  const [passwordWallet, setPasswordWallet] = useState('')
  const [coinsInfo, setCoinsInfo] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [planInfo, setPlanInfo] = useState([]);
  // const [disabled, setDisabled] = useState(true);

  useEffect(()=> {
  }, [])
  useEffect(()=> {
    setPlanInfo(props.planInfo)
    setCoinsInfo(props.coinsInfo)
  }, [props.coinsInfo,props.planInfo])
  
  useEffect(()=> {
    filterCoins()
  }, [coins])

  const hiddenModal = onHide;

  const walletFaltants = ()=> {
    let result = 0;
    coinsInfo.forEach((row) => {
      if (coinWallet !== "") {
        if (row.coin === coinWallet) {
          result = row.wallets;
        }
      }
    });
    return result;
  }

  const filterCoins = () => {
    let filter_options;
    if (coins && coins.length > 0) {
      filter_options = coins.filter(coin => coin.symbol !== "vmxn" && coin.symbol !== "usd")
    }
    setFilterOptions(filter_options)
  }

  const createWallet = () => {
    if(passwordWallet === "" || coinWallet === "" || aliasWallet === ""){
      return store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      })
    } 

    let w_restant = walletFaltants();
    if (passwordWallet !== "" && coinWallet !== "" && aliasWallet !== "") {
      if(w_restant < Number(planInfo.wallets_per_coin)) {
        let whiskas = Connection.RThzHrsb(passwordWallet);
        let combination2 = Connection.RThzHrsb("XWBX203")
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
          Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "2", whiskas, response => {
            Backend.CreateWallets(localStorage.getItem('email'), localStorage.getItem('token'), coinWallet, aliasWallet, response.payload.r03, response.payload.r01, response => {
              if(response.status.code === '0'){
                hiddenModal();
                store.addNotification({
                  title: "Success!",
                  message: 'Wallet successful',
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                })
                setPasswordWallet('');
                setAliasWallet('');
                setCoinWallet('')
                props.handleWalletCreated(response)
              }else{
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
              }
            })
          })
        })
      }
    }
  }

  const handleSelectCoinsChange = (e) => {
    setCoinWallet(e.symbol);
  }

  return (
    <>
        <Modal
          show={show}
          onHide={onHide}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header style={{borderBottom: 'none'}} closeButton>
            <Modal.Title style={{width: '100%', textAlign: 'center'}}>{props.traductions.wallets.Index.modalAdd.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row style={{marginBottom: '15px'}}>
              <Col xl={2}>
                <Form.Label>{props.traductions.wallets.Index.modalAdd.wallet}</Form.Label>
              </Col>
              <Col xl={10}>
                <SelectWalletCoins options={filterOptions} onChange={handleSelectCoinsChange}/>
                <span style={{color: '#1F45FF'}}>Wallets: {wallets && wallets.length}</span>
              </Col>
            </Row>
            <Row style={{marginBottom: '20px'}}>
              <Col xl={2}>
                <Form.Label>{props.traductions.wallets.Index.modalAdd.L_Alias}</Form.Label>
              </Col>
              <Col xl={10}>
                <Form.Control
                  type="text"
                  placeholder={props.traductions.wallets.Index.modalAdd.P_Alias}
                  onChange={(e) => setAliasWallet(e.target.value)}
                />
              </Col>
            </Row>
            <Row style={{marginBottom: '20px'}}>
              <Col xl={2}>
                <Form.Label htmlFor="inputPassword">{props.traductions.wallets.Index.modalAdd.L_Pass}</Form.Label>
              </Col>
              <Col xl={10}>
                <Form.Control
                  type="password"
                  id="inputPassword"
                  aria-describedby="passwordHelpBlock"
                  placeholder="********"
                  onChange={(e) => setPasswordWallet(e.target.value)}
                />
                <span style={{color: '#1F45FF'}}>{props.traductions.wallets.Index.modalAdd.N_Pass}</span>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer style={{justifyContent: 'center'}}>
            <Button onClick={createWallet} variant="primary">{props.traductions.wallets.Index.modalAdd.btn}</Button>
          </Modal.Footer>
        </Modal>
      
    </>
  );
}

export default ModalWallets;